import React, { PureComponent } from 'react';
import AirportDropdown from './AirportDropdown';
import Fuse from 'fuse.js';

export class AirportsInput extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentValue: ''
        }
        /** init fuse for elastic search */
        this.fuse = { search: () => [] };
    }
    /** we got to refresh the data of fuse before update */
    UNSAFE_componentWillUpdate(props) {
        this.fuse = new Fuse(props.airports, {
            shouldSort: true,
            threshold: 0.2,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
        });
    }
    render() {
        return <>
            <input
                onKeyUp={this.props.onKeyUp}
                onChange={event => this.setState({ currentValue: event.target.value })}
                autoComplete="off"
                type="text"
                className="form-control text-transform-uppercase"
                id={this.props.id}
                name={this.props.name}
                maxLength="3"
                placeholder={this.props.placeholder} />
            <AirportDropdown
                searchCriteria={this.state.currentValue}
                show={this.state.currentValue.length > 0}
                corresponding={this.fuse.search(this.state.currentValue).map((key) => this.props.airports[key])}
                {...this.props}
            />
        </>
    }
}
